import type { PortfolioReport } from '@interfaces/portfolioReport';
import { Box, Typography } from 'hephaestus/web';
import type { ReactNode } from 'react';
import { resolvePortfolioDisplayCurrencies } from '../../utils/presentation/portfolioCurrencyPresentation';
import { BulkRebalancePortfolioCurrencyFlags } from './portfolioCurrencyFlags';

export type BulkRebalancePortfolioTableCellProps = {
  clientLabel: string;
  goalLabel?: string;
  report?: PortfolioReport | null;
  flagsTestId?: string;
  secondaryHint?: ReactNode;
};

/** Portfolio name column with leading currency flags, matching platform table cells. */
export const BulkRebalancePortfolioTableCell = ({
  clientLabel,
  goalLabel,
  report,
  flagsTestId,
  secondaryHint,
}: BulkRebalancePortfolioTableCellProps) => {
  const hasFlags =
    !!report && resolvePortfolioDisplayCurrencies(report).length > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: hasFlags ? 0.75 : 0,
        minWidth: 0,
      }}
    >
      {hasFlags ? (
        <Box sx={{ flexShrink: 0, pt: 0.25 }}>
          <BulkRebalancePortfolioCurrencyFlags
            report={report}
            testId={flagsTestId}
          />
        </Box>
      ) : null}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          minWidth: 0,
          flex: '1 1 auto',
        }}
      >
        <Typography variant='bodyMedium' sx={{ fontWeight: 600 }}>
          {clientLabel}
        </Typography>
        {secondaryHint ??
          (goalLabel ? (
            <Typography
              variant='labelSmall'
              color='textSecondary'
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {goalLabel}
            </Typography>
          ) : null)}
      </Box>
    </Box>
  );
};
